/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAutotaskTicketFields200ResponseStatusesInner } from './GetAutotaskTicketFields200ResponseStatusesInner';
import {
    GetAutotaskTicketFields200ResponseStatusesInnerFromJSON,
    GetAutotaskTicketFields200ResponseStatusesInnerFromJSONTyped,
    GetAutotaskTicketFields200ResponseStatusesInnerToJSON,
    GetAutotaskTicketFields200ResponseStatusesInnerToJSONTyped,
} from './GetAutotaskTicketFields200ResponseStatusesInner';

/**
 * Ticket picklists read during the test, so a new configuration can fill its dropdowns before it has been saved
 * @export
 * @interface TestAutotaskConnection200ResponseFields
 */
export interface TestAutotaskConnection200ResponseFields {
    /**
     * 
     */
    statuses?: Array<GetAutotaskTicketFields200ResponseStatusesInner>;
    /**
     * 
     */
    priorities?: Array<GetAutotaskTicketFields200ResponseStatusesInner>;
    /**
     * 
     */
    queues?: Array<GetAutotaskTicketFields200ResponseStatusesInner>;
    /**
     * 
     */
    ticketTypes?: Array<GetAutotaskTicketFields200ResponseStatusesInner>;
}

/**
 * Check if a given object implements the TestAutotaskConnection200ResponseFields interface.
 */
export function instanceOfTestAutotaskConnection200ResponseFields(value: object): value is TestAutotaskConnection200ResponseFields {
    return true;
}

export function TestAutotaskConnection200ResponseFieldsFromJSON(json: any): TestAutotaskConnection200ResponseFields {
    return TestAutotaskConnection200ResponseFieldsFromJSONTyped(json, false);
}

export function TestAutotaskConnection200ResponseFieldsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestAutotaskConnection200ResponseFields {
    if (json == null) {
        return json;
    }
    return {
        
        'statuses': json['statuses'] == null ? undefined : ((json['statuses'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerFromJSON)),
        'priorities': json['priorities'] == null ? undefined : ((json['priorities'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerFromJSON)),
        'queues': json['queues'] == null ? undefined : ((json['queues'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerFromJSON)),
        'ticketTypes': json['ticketTypes'] == null ? undefined : ((json['ticketTypes'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerFromJSON)),
    };
}

export function TestAutotaskConnection200ResponseFieldsToJSON(json: any): TestAutotaskConnection200ResponseFields {
    return TestAutotaskConnection200ResponseFieldsToJSONTyped(json, false);
}

export function TestAutotaskConnection200ResponseFieldsToJSONTyped(value?: TestAutotaskConnection200ResponseFields | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statuses': value['statuses'] == null ? undefined : ((value['statuses'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerToJSON)),
        'priorities': value['priorities'] == null ? undefined : ((value['priorities'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerToJSON)),
        'queues': value['queues'] == null ? undefined : ((value['queues'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerToJSON)),
        'ticketTypes': value['ticketTypes'] == null ? undefined : ((value['ticketTypes'] as Array<any>).map(GetAutotaskTicketFields200ResponseStatusesInnerToJSON)),
    };
}

